export default __webpack_public_path__ + "static/media/739.c823939b.gif";